import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { NavBar } from "../components/NavBar";
import { track } from "../lib/api";

export default function PaymentCancel() {
  const navigate = useNavigate();
  useEffect(() => {
    track("checkout_abandoned");
  }, []);
  return (
    <>
      <NavBar />
      <main className="container-nc" style={{ paddingTop: 70, paddingBottom: 90, maxWidth: 520, textAlign: "center" }} data-testid="payment-cancel">
        <span style={{ width: 72, height: 72, borderRadius: "50%", background: "var(--surface-4)", display: "grid", placeItems: "center", margin: "0 auto" }}>
          <XCircle size={38} color="var(--muted)" />
        </span>
        <h1 style={{ fontSize: "1.8rem", fontWeight: 600, marginTop: 20 }}>Checkout cancelled</h1>
        <p style={{ color: "var(--muted)", lineHeight: 1.6 }}>
          No charge was made. You can upgrade to Pro any time.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 22 }}>
          <button className="btn btn-ghost btn-lg" onClick={() => navigate("/")}>
            Back to home
          </button>
          <button className="btn btn-primary btn-lg" onClick={() => navigate("/paywall")}>
            View plans
          </button>
        </div>
      </main>
    </>
  );
}
